import { useEffect } from 'react';

/**
 * Sets the browser tab title for as long as the calling component is
 * mounted, restoring the previous one on unmount. One build serves every
 * portal, so index.html can only carry the main app's title; the training
 * route tree uses this to name its tab.
 */
export function useDocumentTitle(title: string): void {
  useEffect(() => {
    const previous = document.title;
    document.title = title;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
